import { render, staticRenderFns } from "./LoanCollateralAssetOtherFieldsDisplay.vue?vue&type=template&id=1c07d85a&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetOtherFieldsDisplay.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetOtherFieldsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetOtherFieldsDisplay.vue?vue&type=style&index=0&id=1c07d85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07d85a",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetOtherFieldsDisplay.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports